import styled, { css } from "styled-components";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Wrapper = styled.div`
  display: ${({ isShown }) => (isShown ? "flex" : "none")};
  flex-wrap: wrap;
  width: 100%;

  ${({ isExpandedAreaSection }) =>
    isExpandedAreaSection &&
    css`
      display: flex;
    `};

  @media screen and (max-width: ${largeScreen}px) {
    display: none;
    flex: 1;
    flex-direction: column;
    align-items: center;

    ${({ isShown }) =>
      isShown &&
      css`
        display: block;
      `};
  }
`;
export const ShowButton = styled(ButtonAction).attrs({
  theme: buttonActionThemes.DARK_PRIMARY
})`
  display: ${({ isContentShown }) => (isContentShown ? "none" : "block")};
  margin: 0;
  max-width: 240px;

  ${({ isExpandedAreaSection }) =>
    isExpandedAreaSection &&
    css`
      display: none;
    `};

  @media screen and (max-width: ${largeScreen}px) {
    display: ${({ isContentShown }) => (isContentShown ? "none" : "block")};
    margin: 0 auto;
    max-width: 240px;
    width: 240px;
  }
`;
